import { useEffect } from "react";
import { realtimeService, RealtimeEvent } from "@/lib/realtime-service";

export function RealtimeNotifications() {
  useEffect(() => {
    const unsubscribe = realtimeService.subscribe(handleRealtimeEvent);
    return unsubscribe;
  }, []);

  const handleRealtimeEvent = (event: RealtimeEvent) => {
    // Real-time events are now handled silently
    // Toast notifications are shown directly from user actions in authenticated-app.tsx
    // This prevents duplicate toasts
    console.log('Real-time event received:', event.type);
  };

  return null;
}